import { Copy, X } from 'lucide-react';

/**
 * Detalhes do pagamento por PIX de uma venda.
 *
 * Mora fora do SaleList porque é uma tela inteira (QR + chave copiável) que não
 * tem nada a ver com a listagem: junto, o arquivo da lista passava de 500
 * linhas e a leitura do card ficava enterrada no meio do modal.
 */
export const PixModal = ({
  open,
  onClose,
  pixKey,
  qrCode
}: {
  open: boolean;
  onClose: () => void;
  pixKey: string | null;
  qrCode: string | null;
}) => {
  const handleCopyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      alert('Chave PIX copiada para a área de transferência.');
    });
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
      <div className="bg-card cartao shadow-xl max-w-md w-full mx-4 p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold">Pagamento PIX</h3>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-4">
          {/* QR Code */}
          {qrCode && (
            <div className="flex flex-col items-center gap-2">
              <span className="text-sm text-muted-foreground">QR Code</span>
              <img
                src={qrCode}
                alt="PIX QR Code"
                className="w-48 h-48 border rounded"
                title="QR Code PIX"
              />
            </div>
          )}

          {/* PIX Key */}
          {pixKey && (
            <div className="space-y-2">
              <span className="text-sm text-muted-foreground">Chave PIX</span>
              <div className="flex items-center justify-between gap-2 bg-muted p-3 rounded border">
                <code className="text-foreground font-mono break-all text-xs">{pixKey}</code>
                <button
                  onClick={() => handleCopyToClipboard(pixKey)}
                  className="flex items-center gap-1 px-3 py-1.5 rounded bg-blue-600 text-white hover:bg-blue-700 font-semibold flex-shrink-0 text-sm"
                >
                  <Copy className="h-3 w-3" />
                  Copiar
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
